'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Services liés à la page de gestion des éditions rapides

 * Elements du scope partagés avec l'appelant (soit lu, soit modifié) :
 * $scope.classificationsMap
 * $scope.produits
 * $scope.displayProduits
 * $scope.hasDirty
 * $scope.resultat
 * $scope.error
 *
 * Elements du scope positionnés par le service à ses propres fins (pas utilisés par l'appelant) :
 * $scope.paramsAll
 * $scope.appliqueValeurCategorieAll
 * $scope.ouiNon
 * $scope.totalImputation
 */
ngModule.factory("saisieEditionRapideService", function ($q, $http, contextService, $notifications, $dialogBox, groupeService, classificationService) {
  return {
    refreshData: function refreshData($scope, listUrl, checkLigneCallback) {
      return $http.get(listUrl).then(function (response) {
        $scope.produits = response.data;

        // make model dirty
        _.each($scope.produits, function (model) {
          $scope.$watch(function () {
            return model;
          }, function (newModel, oldModel) {
            if (newModel === oldModel) {
              return;
            }
            model.$dirty = true;
            $scope.hasDirty = true;
            checkLigneCallback(model);
          }, true);
        });
      });
    },
    save: function save($scope, saveUrl, checkLigneCallback) {
      var modified = [];
      var error = false;
      _.each($scope.produits, function (model) {
        if (model.$dirty) {
          modified.push(model);
          if (checkLigneCallback(model)) {
            error = true;
          }
        }
      });
      $scope.error = error;
      if (!error) {
        return $http.post(saveUrl, modified).then(function (response) {
          $scope.resultat = response.data;
          if ($scope.resultat.errorProduitIds.length > 0) {
            $notifications.error("" + $scope.resultat.errorProduitIds.length + " erreur(s) à l'enregistrement");
          } else {
            if ($scope.resultat.savedProduitIds.length === 1) {
              $notifications.info("Mise à jour effectuée pour 1 ligne");
            } else {
              $notifications.info("Mise à jour effectuée pour " + $scope.resultat.savedProduitIds.length + " lignes");
            }
            $scope.hasDirty = false;
          }
          _.each(modified, function (model) {
            model.$dirty = $scope.resultat.savedProduitIds.indexOf(model.id) === -1;
          });
        });
      }
    },
    getErrorColumn: function getErrorColumn() {
      return {
        attribute: 'error',
        title: '',
        sortable: true,
        sortType: "boolean",
        template: "\n                        <span>\n                            <i ng-if=\"model.error==true || (resultat!=null && resultat.errorProduitIds.indexOf(model.id) !== -1)\" title=\"Erreur\" class=\"mr-s fa not-allowed fa-ban\" ></i>\n                            <i ng-if=\"model.error!=true && model.$dirty\" title=\"Modifi\xE9\" class=\"mr-s fa allowed fa-check-square-o\" ></i>\n                        </span>\n                    ",
        cellClass: 'align-c',
        width: '25px'
      };
    },
    addClassificationColumGroups: function addClassificationColumGroups(classifications, columnGroups) {
      var idx = 0;
      for (var i = 0; i < classifications.length; i++) {
        columnGroups.push({
          id: "classification-" + i,
          title: classifications[i].nom,
          columns: ["classification-" + i],
          visible: false
        });
        idx++;
      }
    },
    addClassificationColumns: function addClassificationColumns($scope, classifications, columns, $translate) {
      var idx = 0;
      $scope.ouiNon = [{
        id: true,
        label: $translate('common.Oui')
      }, {
        id: false,
        label: $translate('common.Non')
      }];
      classificationService.getUtilisateursPourTaches(true).then(function (users) {
        $scope.users = users;
      });
      groupeService.getGroupes().then(function (groupes) {
        $scope.groupes = groupes;
      });
      var _loop = function _loop() {
        var classification = classifications[i];
        if (classification.type === 'CLASSIFICATION') {
          // Champs additionnels de type Classification
          if (!classification.multiple) {
            // Classification mono-valeur
            if ($scope.paramsAll === undefined) {
              $scope.paramsAll = {
                classificationAll: {}
              };
              $scope.appliqueValeurCategorieAll = function (classificationId, idx) {
                var classification = $scope.classificationsMap[classificationId];
                var text = $scope.paramsAll.classificationAll[idx] == null ? "Toutes les lignes seront modifiées pour en ôter la valeur de classification choisie, confirmez-vous cette action ?" : "Toutes les lignes seront modifiées avec la valeur de classification choisie, confirmez-vous cette action ?";
                $dialogBox.confirm({
                  title: "Modifier les valeurs de la classification " + classification.nom,
                  text: text
                }).then(function () {
                  var nb = 0;
                  _.each($scope.displayProduits, function (model) {
                    if (model.classificationFields[idx].canEdit && model.classificationFields[idx].imputations[0].classificationValueId !== $scope.paramsAll.classificationAll[idx]) {
                      model.classificationFields[idx].imputations[0].classificationValueId = $scope.paramsAll.classificationAll[idx];
                      nb++;
                    }
                  });
                  $notifications.info(nb + " lignes modifiées");
                });
              };
            }
            // initialise à null pour permettre la suppression par défaut (1ere valeur).
            $scope.paramsAll[idx] = null;
            columns.push({
              id: "classification-" + idx,
              headerTemplate: '<div><span>' + classification.nom + '</span> ' + '<div><tl-select option-label-attribute="nom" tl-stop-event-propagation  ng-model="paramsAll.classificationAll[' + idx + ']" ' + 'options="classificationsMap[\'' + classification.id + '\'].valeurs" ' + 'empty-option-label="--Retirer--"></tl-select>' + '<tl-icon-button tl-stop-event-propagation icon="fa-level-down" ng-click="appliqueValeurCategorieAll(\'' + classification.id + '\', ' + idx + ')"> </tl-icon-button>' + '</div></div>',
              title: classification.nom,
              template: '<span ng-if="model.classificationFields[' + idx + '].canEdit"><tl-select style="width:70%"' + 'ng-model="model.classificationFields[' + idx + '].imputations[0].classificationValueId" ' + ' option-label-attribute="nom" options="classificationsMap[\'' + classification.id + '\'].valeurs" empty-option-label=""></tl-select>' + '</span>',
              cellClass: "align-c",
              attribute: 'classificationFields.' + idx + '.imputations.O.classificationValueId',
              sortType: new function () {
                var index = idx;
                var classificationId = classification.id;
                var valeurs = $scope.classificationsMap[classificationId].valeurs;
                // console.log('valeurs', valeurs);
                var valeurParId = new Map();
                valeurs.forEach(function (valeur) {
                  valeurParId.set(valeur.id, valeur.nom);
                });
                // console.log('valeurParId', valeurParId);
                return function (l1, l2) {
                  var id1 = l1.classificationFields[index].imputations[0].classificationValueId;
                  var id2 = l2.classificationFields[index].imputations[0].classificationValueId;
                  // console.log('id1', id1);
                  var v1 = valeurParId.get(id1) || "";
                  var v2 = valeurParId.get(id2) || "";
                  var res = v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
                  // console.log('v1', v1, "v2", v2, res);
                  return res;
                };
              }(),
              sortable: true
            });
            idx++;
          } else {
            // Classification multi-valeurs
            columns.push({
              id: "classification-" + idx,
              title: classification.nom,
              template: "\n                                    <div ng-if=\"model.classificationFields[".concat(idx, "].canEdit\" class=\"classif-overflow-y-auto\">\n                                        <div ng-repeat=\"imputation in model.classificationFields[").concat(idx, "].imputations\">\n                                            <tl-select style=\"min-width: 80px\" ng-model=\"imputation.classificationValueId\" options=\"classificationsMap['").concat(classification.id, "'].valeurs\" option-label-attribute=\"nom\" empty-option-label=\"\"></tl-select>\n                                            <span ng-if=\"model.classificationFields[").concat(idx, "].repartition==true\">\n                                                <tl-percent-input style=\"width:6em\" ng-model=\"imputation.imputation\"></tl-percent-input>\n                                            </span>\n                                        </div>\n                                        <span ng-if=\"model.classificationFields[").concat(idx, "].repartition==true\" class=\"b\" tl-tooltip=\"Total des imputations\" ng-class=\"{'red': totalImputation(model.classificationFields[").concat(idx, "].imputations)>100.000001}\">{{totalImputation(model.classificationFields[").concat(idx, "].imputations)}} %</span>\n                                        <i class=\"fa fa-plus-circle blue action-icon\" ng-click=\"addClassificationValue(model.classificationFields[").concat(idx, "])\"></i>\n                                    </div>\n                                "),
              cellClass: "align-r",
              attribute: 'classificationFields.' + idx + '.imputations.O.classificationValueId',
              sortable: true
            });
            idx++;
          }
        } else {
          // Champs additionnels de type Champ libre
          columns.push({
            id: "classification-" + idx,
            title: classification.nom,
            template: "\n                                <div ng-if=\"model.classificationFields[".concat(idx, "].canEdit\" class=\"classif-overflow-y-auto\">\n                                    <div ng-repeat=\"imputation in model.classificationFields[").concat(idx, "].imputations\">\n                                        <input class=\"full-width\" ng-if=\"imputation.type==='STRING'\" size=\"15\" ng-model=\"imputation.valueAsString\">\n                                        <input input-type-number number-integer ng-if=\"imputation.type==='LONG'\" ng-model=\"imputation.valueAsLong\" size=\"15\">\n                                        <input input-type-number ng-if=\"imputation.type==='DOUBLE'\" ng-model=\"imputation.valueAsDouble\" size=\"15\">\n                                        <span ng-if=\"imputation.type==='POURCENTAGE'\">\n                                        <tl-percent-input input-type-number ng-model=\"imputation.valueAsPourcentage\" size=\"15\">\n                                            </span>\n                                            <span ng-if=\"imputation.type==='BOOLEAN'\">\n                                          <select ng-model=\"imputation.valueAsBoolean\" ng-options=\"o.id as o.label for o in ouiNon\" tl-null-option=\"\"></select>\n                                        </span>\n                                 <span ng-if=\"imputation.type==='UTILISATEUR'\">\n                                  <tl-select ng-model=\"imputation.valueAsString\"\n                                          options=\"users\" empty-option-label=\"Aucun\"></tl-select>\n                                                                       <i class=\"fa fa-plus-circle blue action-icon\" \n                             ng-if=\"model.classificationFields[").concat(idx, "].multiple\"\n                             ng-click=\"addClassificationValue(model.classificationFields[").concat(idx, "])\"></i>\n\n                                </span>\n                                <span ng-if=\"imputation.type==='GROUPE'\">\n                                  <select ng-model=\"imputation.valueAsString\"\n                                          ng-options=\"g.id as g.nom for g in groupes\" tl-null-option=\"Aucun\"></select>\n                             <i class=\"fa fa-plus-circle blue action-icon\" \n                             ng-if=\"model.classificationFields[").concat(idx, "].multiple\"\n                             ng-click=\"addClassificationValue(model.classificationFields[").concat(idx, "])\"></i>\n\n                            </span>\n\n                                        <input ng-if=\"imputation.type==='DATEMIDNIGHT'\"\n                                               ng-model=\"imputation.valueAsDateMidnight\" input-type-date tl-datepicker>\n                                    </div>\n                                </div>\n                                "),
            cellClass: "align-c",
            attribute: 'classificationFields.' + idx + '.imputations.O.classificationValueId',
            sortable: true
          });
          idx++;
        }
      };
      for (var i = 0; i < classifications.length; i++) {
        _loop();
      }
      // total des imputations
      if (classifications.length > 0) {
        $scope.totalImputation = function (imputations) {
          var total = 0.0;
          _.each(imputations, function (imputation) {
            if (imputation.classificationValueId != null) {
              total += imputation.imputation;
            }
          });
          return total;
        };
      }
    },
    addClassificationValue: function addClassificationValue(classificationField) {
      if (classificationField.type == 'UTILISATEUR' || classificationField.type == 'GROUPE') {
        classificationField.imputations.push({
          classificationValueId: null,
          valueAsString: null,
          champAdditionnel: true,
          type: classificationField.type
        });
      } else {
        // console.log('addClassificationValue for', classificationField);
        classificationField.imputations.push({
          classificationValueId: null,
          imputation: classificationField.multiple ? 100.0 : 0.0
        });
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/saisieEditionRapideService.js
// module id = 2879
// module chunks = 13